<h1 mat-dialog-title><strong>Importer le cours</strong></h1>

<form #f="ngForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <div class="form-group mb-4">
      <input
        (change)="pdfLessonFileBrowseHandler($event.target.files)"
        class="form-control mt-1 mb-3"
        id="importPdfLessonFile"
        name="importPdfLessonFile"
        accept="application/pdf"
        type="file" />
    </div>
  </div>

  <mat-dialog-actions class="justify-content-end">
    <button mat-dialog-close mat-raised-button>Annuler</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!isSubmitOk">Importer le cours</button>
  </mat-dialog-actions>
</form>
